import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import ApiConstants from 'src/app/shared/constants/api.constants';
import { isPlatformBrowser } from '@angular/common';
import { jwtDecode } from 'jwt-decode';
import { Router } from '@angular/router';
import { LoginResponse } from '../../shared/model/auth.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  public getAuthToken(): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('authToken');
    }

    return null;
  }

  private decodeToken(token: string) {
    try {
      return jwtDecode(token);
    } catch (e) {
      return e;
    }
  }

  private isTokenValid(decodedToken: { exp?: number }): boolean {
    const expirationTime = decodedToken?.exp;

    if (expirationTime) {
      const currentTime = Math.floor(Date.now() / 1000);
      return expirationTime > currentTime;
    }

    return false;
  }

  isAuthenticated(): boolean {
    const token = this.getAuthToken();

    if (token) {
      const decodedToken = this.decodeToken(token);

      if (decodedToken && this.isTokenValid(decodedToken)) {
        return true;
      }
    }

    return false;
  }

  logout(): void {
    this.router.navigate(['/signIn']);
    localStorage.clear();
  }

  verifyOtp(email: string, otp: string): Observable<LoginResponse> {
    const API_URL = `${this.apiUrl}${ApiConstants.VERIFY_OTP_FOR_ADMIN}`;
    return this.http.post<LoginResponse>(API_URL, { email, otp }).pipe(map((response) => response));
  }

  login(email: string, password: string) {
    const API_URL = `${this.apiUrl}${ApiConstants.SIGN_IN}`;

    return this.http
      .post<LoginResponse>(API_URL, { email, password })
      .pipe(map((response) => response));
  }

  resendOtp(email: string) {
    const API_URL = `${this.apiUrl}${ApiConstants.RESEND_OTP_FOR_ADMIN}`;
    const payload = {
      phoneNumber: '',
      email,
      otpType: 'Email',
      otpRequestType: 'SignIn',
    };
    return this.http.post(API_URL, payload).pipe(map((response) => response));
  }
}
